module.exports = __webpack_public_path__ + "static/img/ent-48.bd30140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-48.jpg
// module id = lXo8
// module chunks = 52